export default __webpack_public_path__ + "static/media/transferencia_pierde.f58022fd.png";